import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { CTASection } from '../components/CTASection';
import { articles, insightCategories } from '../data/insights';
export function Insights() {
  const [category, setCategory] = useState('All');
  const featured = articles.find(a => a.featured) ?? articles[0];
  const rest = articles.filter(a => a !== featured);
  const visible = category === 'All' ? rest : rest.filter(a => a.category === category);
  return <>
      <PageHeader eyebrow="Insights" title="Notes from the work." intro="Essays on company building, capital, leadership and the long arc of African innovation." data-id="element-374" data-mp="2nv3fuefi8vie" />

      {/* Featured */}
      <section className="px-6 sm:px-10" data-id="element-375" data-mp="1cij5n8ts80jv">
        <div className="mx-auto max-w-[92rem]" data-id="element-376" data-mp="1hg2l2c27ujde">
          <Reveal data-id="element-377" data-mp="1hguh1nzq6j47">
            <a href="#latest" className="group grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-378" data-mp="1hd6nwpy6zyq0">
              <div className="overflow-hidden rounded-[2rem] border border-charcoal/[0.07] lg:col-span-7" data-id="element-379" data-mp="s5aj8wqbdbjm">
                <img src={featured.image} alt="" className="aspect-[3/2] w-full object-cover transition-transform duration-[1.8s] ease-editorial group-hover:scale-[1.04]" data-id="element-380" data-mp="o3z1fddolulz" />
              </div>
              <div className="lg:col-span-5 lg:self-center" data-id="element-381" data-mp="1b0r31ijg152d">
                <p className="eyebrow text-mocha" data-id="element-382" data-mp="17106szb5dwqg">
                  Featured · {featured.category}
                </p>
                <h2 className="mt-6 font-serif text-[2.25rem] font-light leading-[1.06] tracking-[-0.01em] text-charcoal sm:text-[3rem]" data-id="element-383" data-mp="1kqtuvfetwcz4">
                  {featured.title}
                </h2>
                <p className="mt-6 text-[1.0625rem] leading-[1.8] text-charcoal/65" data-id="element-384" data-mp="1up9l7g617i7k">
                  {featured.excerpt}
                </p>
                <p className="mt-8 text-xs uppercase tracking-[0.16em] text-charcoal/40" data-id="element-385" data-mp="1poveq2k2wgbn">
                  {featured.date} · {featured.readTime} read
                </p>
              </div>
            </a>
          </Reveal>
        </div>
      </section>

      {/* Filters + grid */}
      <section id="latest" className="px-6 pb-28 pt-24 sm:px-10 sm:pb-40" data-id="element-386" data-mp="26qri4syfkx4h">
        <div className="mx-auto max-w-[92rem]" data-id="element-387" data-mp="2bk44sxjjutul">
          <div className="flex flex-wrap gap-2 border-y border-charcoal/[0.08] py-5" data-id="element-388" data-mp="2bkvp3c7p555k">
            {insightCategories.map(c => <button key={c} type="button" onClick={() => setCategory(c)} className={`rounded-full px-4 py-2 text-[0.75rem] uppercase tracking-[0.12em] transition-all duration-500 ${category === c ? 'bg-charcoal text-ivory' : 'text-charcoal/55 hover:bg-charcoal/[0.05] hover:text-charcoal'}`} data-id="element-389" data-mp="2kj7n3zaw7581">
                {c}
              </button>)}
          </div>

          {visible.length === 0 ? <p className="py-24 text-center font-serif text-2xl font-light text-charcoal/50" data-id="element-390" data-mp="smhbubnbp1vb">
              Nothing published in {category} yet — more is on the way.
            </p> : <motion.div layout className="grid gap-x-12 gap-y-16 pt-16 md:grid-cols-2 lg:grid-cols-3" data-id="element-391" data-mp="isgzboppouck">
              {visible.map((a, i) => <Reveal key={a.slug} delay={i % 3 * 0.08} as="article" data-id="element-392" data-mp="1bjiie0wiza1d" data-mpi={i}>
                  <a href="#latest" className="group block" data-id="element-393" data-mp="16k5udctx3wx7">
                    <div className="aspect-[3/2] overflow-hidden rounded-[1.5rem] border border-charcoal/[0.07]" data-id="element-394" data-mp="16kxglx1mkiat">
                      <img src={a.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.6s] ease-editorial group-hover:scale-[1.05]" data-id="element-395" data-mp="11n5p344w6y75" />
                    </div>
                    <p className="eyebrow mt-6 text-charcoal/40" data-id="element-396" data-mp="1a1a4qjwhsqlw">
                      {a.category} · {a.date}
                    </p>
                    <h3 className="mt-3 font-serif text-[1.5rem] font-light leading-[1.16] text-charcoal" data-id="element-397" data-mp="1ess3d1b1mf3p">
                      {a.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-charcoal/55" data-id="element-398" data-mp="151nriagnzad3">
                      {a.excerpt}
                    </p>
                    <span className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.14em] text-charcoal/50 transition-colors group-hover:text-charcoal" data-id="element-399" data-mp="1sst5ek31nskr">
                      Read · {a.readTime}
                      <ArrowUpRightIcon className="h-3.5 w-3.5 transition-transform duration-500 ease-editorial group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.4} data-id="element-400" data-mp="1it2bajiebfl7" />
                    </span>
                  </a>
                </Reveal>)}
            </motion.div>}
        </div>
      </section>

      <CTASection data-id="element-401" data-mp="2qn3y3v0uey8t" />
    </>;
}